module.exports = __webpack_public_path__ + "static/media/RedBullLogo.b2c35561.png";